class DonutChartController extends Controller {

  connect() {
    this.element.classList.add('donut-chart')
    const NS = "http://www.w3.org/2000/svg"
    const svg = document.createElementNS(NS, "svg")
    const circle = document.createElementNS(NS, "circle")
    const title = document.createElement('div')

    if (this.percentage > 100) {
      circle.classList.add('red')
    }

    circle.setAttribute('r', this.radius)
    circle.setAttribute('cx', this.radius)
    circle.setAttribute('cy', this.radius)

    svg.setAttribute('viewBox', `0 0 ${ this.diameter } ${ this.diameter }`)

    title.classList.add('donut-title')
    title.textContent = this.titleText
    const children = [...this.element.childNodes].filter(node => node.nodeType === Node.ELEMENT_NODE)
    this.element.textContent = ''
    children.forEach(child => this.element.appendChild(child))

    this.element.appendChild(title)
    svg.appendChild(circle)
    this.element.appendChild(svg)

    circle.setAttribute('stroke-dasharray', `0 ${ this.circumference }`)
    setTimeout(() => { circle.setAttribute('stroke-dasharray', `${ this.pathLength } ${ this.circumference }`) }, 100)
  }

  get percentage() {
    return parseFloat(this.element.dataset.percentage)
  }

  get radius() {
    return parseInt(this.element.dataset.radius)
  }

  get diameter() {
    return 2 * this.radius
  }

  get circumference() {
    return Math.ceil(this.radius * 2 * Math.PI)
  }

  get pathLength() {
    return Math.ceil((this.percentage / 100) * this.circumference)
  }

  get titleText() {
    return this.element.textContent
  }
}

export default DonutChartController



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/donut-chart-controller.js